import React from 'react';
import { FieldErrors } from 'react-hook-form';
import { Flex, Box, Input, Label, Button, ThemeUIStyleObject } from 'theme-ui';
type Props = {
  name: string;
  label: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  dataCategory?: string;
  dataAction?: string;
  dataLabel?: string;
  forwardSx?: ThemeUIStyleObject;
  submitButton?: boolean;
  errors?: FieldErrors;
  disabled?: boolean;
  placeholder?: string;
};
const FormInputWithLabel = React.forwardRef<HTMLInputElement, Props>(
  ({ name, label, forwardSx, submitButton, placeholder, onChange, onBlur, disabled }, ref) => {
    return (
      <Flex
        sx={{
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          borderBottom: '1px solid black',
          position: 'relative',
          height: '100%',
          width: '100%',
          ...forwardSx,
        }}
      >
        <Box sx={{ position: 'relative', flex: '1 1 0', fontFamily: 'heading' }}>
          <Input
            sx={{
              fontSize: '1.6rem',
              letterSpacing: '1px',
              width: 'calc(100% - 3em)',
              marginBottom: '-8px',
              paddingLeft: [null, null, '1rem'],
              variant: 'text.body',

              '::placeholder': {
                variant: 'text.link',
                fontSize: ['1.6rem'],
                textTransform: 'capitalize',
              },

              ':not(:placeholder-shown) + label': {
                opacity: '.75',
              },
              ':disabled': {
                borderColor: 'UIGray2',
                color: 'UIGray2',
              },
              borderBottom: 'none',
            }}
            onChange={onChange}
            onBlur={onBlur}
            name={name}
            ref={ref}
            placeholder={placeholder}
            disabled={disabled}
          />
        </Box>
        <Label
          htmlFor={name}
          sx={{
            position: 'absolute',
            top: ['8px', null, '12px'],
            left: '15px',
            opacity: '0',
            letterspacing: '1px',
            pointerEvents: 'none',
          }}
        >
          {label}
        </Label>
        {submitButton && (
          <Button
            variant="bare"
            type="submit"
            sx={{
              textTransform: 'uppercase',
              fontWeight: 'bold !important',
              marginBottom: '-8px',
              pr: 0,
              outline: 'none',
              fontSize: '1.2rem',
            }}
          >
            Notify Me
          </Button>
        )}
      </Flex>
    );
  }
);
export default FormInputWithLabel;
